/** @jsx jsx */
import { jsx } from "@emotion/react";
import { Link } from "gatsby";
import DynamicSvg from "../DynamicSvg";
import PropsCard from "../../types/PropsCard";

const Card = (props: PropsCard) => {
  const { slug, title, titleLang, color } = props.data;

  return (
    <Link
      to={slug}
      css={{
        // card link
        textAlign: "center",
        fontFamily: "'Zilla Slab', serif",
        fontWeight: 500,
        textDecoration: "none",
        fontSize: "2rem",
        padding: "2rem",
        borderColor: color,
        borderWidth: "0.5rem",
        borderStyle: "solid",
        // animate card when card is hovered/focused
        transitionDuration: "0.3s",
        transitionProperty: "color background-color fill",
        color: "white",
        backgroundColor: color,
        fill: "white",
        "&:hover, &:focus": {
          color: color,
          backgroundColor: "white",
          fill: color,
        },
        // span containing the text
        span: {
          paddingTop: "1.4rem",
          marginBottom: "2rem",
          display: "block",
          position: "relative",
          // custom underline for the text
          "&::before": {
            content: "''",
            position: "absolute",
            top: 0,
            background: color,
            height: "0.25rem",
            left: "51%",
            right: "51%",
            transitionProperty: "left right",
            transitionDuration: "0.3s",
          },
        },
        // animate underline when card is hovered/focused
        "&:hover > span::before, &:focus > span::before, &:active > span::before":
          {
            left: 0,
            right: 0,
          },
      }}
    >
      <span lang={titleLang !== "en" ? titleLang : undefined}>{title}</span>

      <div>
        <DynamicSvg name={slug} />
      </div>
    </Link>
  );
};

export default Card;
